import { useAuth } from "../lib/auth";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-10 h-10 border-2 border-turquoise border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If the current user's role is allowed on this route, render it.
  if (roles && roles.includes(user.role)) {
    return children;
  }

  // Otherwise redirect to the user's home page based on role.
  if (user.role === "pending") return <Navigate to="/pending" replace />;
  if (user.role === "cliente") return <Navigate to="/mi-billetera" replace />;
  return <Navigate to="/dashboard" replace />;
}
